module.exports = __webpack_public_path__ + "img/team-card-bg.d5185e4f.png";